import { AI_PROVIDERS, AGENTS, ProviderKey } from '@/config/aiProviders.config';

/**
 * AI MODEL ROUTING — Phase D completion's AI Models registry. Derived
 * directly from the existing AGENTS provider/model mapping in
 * aiProviders.config.ts (not a parallel invented list), so "who talks to
 * which model" stays defined in exactly one place. `status` is computed
 * honestly from AI_PROVIDERS[provider].configured — today that's false
 * for every provider, so every entry is genuinely 'not_connected'. No
 * latency/cost numbers exist here because nothing has ever actually run.
 *
 * Deliberately a local shape (not types/orchestrator.ts's ModelReference)
 * because that type's provider union ('future_provider' | 'custom') was
 * defined for a different concept and doesn't match ProviderKey — keeping
 * this local avoids a false structural coupling between the two.
 */
export interface ModelRoutingEntry {
  provider: ProviderKey;
  model: string;
  purposeKey: string;
  status: 'configured' | 'not_connected';
}

export const MODEL_ROUTING: ModelRoutingEntry[] = AGENTS.map((a) => ({
  provider: a.provider,
  model: a.model,
  purposeKey: `aiModels.purpose.${a.id}`,
  status: AI_PROVIDERS[a.provider].configured ? 'configured' : 'not_connected',
}));
